/** WBP-188 B1 — finance archive UI helpers (en-PK). */

export const TYPE_OPTIONS = [
  { value: 'all', label: 'All' },
  { value: 'revenue', label: 'Revenue (invoices / payments / credit notes)' },
  { value: 'expenses', label: 'Expenses / bills / vendors' },
  { value: 'journals', label: 'Journals / other' },
  { value: 'banking', label: 'Bank transactions' },
  { value: 'coa', label: 'CoA ledger' },
];

export const ENTITY_CHIP = {
  invoice: { label: 'Invoice', tone: '' },
  customer_payment: { label: 'Payment', tone: 'muted' },
  credit_note: { label: 'Credit note', tone: 'muted' },
  bill: { label: 'Bill', tone: 'warn' },
  expense: { label: 'Expense', tone: '' },
  vendor_payment: { label: 'Vendor payment', tone: 'muted' },
  journal: { label: 'Journal', tone: 'muted' },
  item: { label: 'Item', tone: 'muted' },
  bank_transaction: { label: 'Bank txn', tone: 'muted' },
};

export const emptyFilters = () => ({
  q: '',
  // Default All so owner capital journals are not excluded (mock had Revenue selected).
  type: 'all',
  contact: '',
  documentNumber: '',
  amountMin: '',
  amountMax: '',
  // No date clamp by default — capital remittances are often 2022–2023.
  dateFrom: '',
  dateTo: '',
});

export const formatPkrRs = (value) => {
  if (value == null || value === '' || Number.isNaN(Number(value))) return '—';
  const n = Number(value);
  const abs = Math.abs(n).toLocaleString('en-PK', { maximumFractionDigits: 0 });
  const signed = n < 0 ? `−${abs}` : abs;
  return `Rs\u00a0${signed}`;
};

export const formatArchiveDate = (value) => {
  if (!value) return '—';
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return '—';
  return d.toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: 'numeric' });
};

export const entityChip = (entityType) =>
  ENTITY_CHIP[entityType] || { label: entityType || 'Txn', tone: 'muted' };
